// Konfiguration über Umgebungsvariablen (Vite: .env.local, siehe .env.example).
// Ohne VITE_SUPABASE_URL startet die Oberfläche im Demo-Modus.
export const konfig = {
  supabaseUrl: (import.meta.env?.VITE_SUPABASE_URL as string | undefined) ?? '',
  supabaseAnonKey: (import.meta.env?.VITE_SUPABASE_ANON_KEY as string | undefined) ?? '',
  /** Öffentlicher VAPID-Schlüssel für Push-Nachrichten (optional) */
  vapidPublicKey: (import.meta.env?.VITE_VAPID_PUBLIC_KEY as string | undefined) ?? '',
};
